import { GLOBAL_ERROR_MESSAGE } from '@/lib/constants';
import { QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import * as Sentry from '@sentry/react';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      console.error('error', error);

      Sentry.captureException(error);

      toast.error(GLOBAL_ERROR_MESSAGE, {
        position: 'top-right',
        description: `Error: ${error.message}`,
        closeButton: false,
        className: '!bg-red-500',
        classNames: {
          icon: '!text-background',
          title: '!text-background',
          description: '!text-background',
        },
      });
    },
  }),
});

export { queryClient };
